module.exports = global["jQuery"] = require("-!C:\\VSTSAgent\\_work\\369\\s\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");